module.exports = __webpack_public_path__ + "img/qkw_kejilei.bad5c4c0.gif";